export default {
  activeTag: '*',
  init(moduleEl) {
    const btnEls = moduleEl.querySelectorAll('.js-filter-btn');
    const selectEl = moduleEl.querySelector('.js-filter-select');

    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);
    this.activeTag = searchParams.get('filter[tag]') ?? '*';

    // click listener for desktop filter pills
    btnEls.forEach((btnEl) => {
      btnEl.addEventListener('click', () => {
        if (this.activeTag === btnEl.dataset.filter) return;
        this.seActive(btnEls, btnEl.dataset.filter, selectEl);
        window.smr_eventbus.emit(
          'references_filter_changed',
          btnEl.dataset.filter
        );
      });
    });

    // change listener for mobile filter select
    selectEl.addEventListener('change', () => {
      if (this.activeTag === selectEl.value) return;
      this.seActive(btnEls, selectEl.value, selectEl);
      window.smr_eventbus.emit('references_filter_changed', selectEl.value);
    });

    window.smr_eventbus.on('data loaded: replace_references', () => {
      btnEls.forEach((btnEl) => {
        btnEl.style.pointerEvents = ''; // enable click events after loading
      });
    });
  },
  seActive(btnEls, newTag, selectEl) {
    // sets active class for filter pills and selected value for mobile select
    btnEls.forEach((btnEl) => {
      btnEl.classList.remove('active');
      btnEl.style.pointerEvents = 'none'; // disable click events while loading

      if (btnEl.dataset.filter !== newTag) return;
      btnEl.classList.add('active');
    });
    this.activeTag = newTag;
    selectEl.value = newTag;
  },
};
